import script from "./import-salary-search-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./import-salary-search-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__